module.exports = __webpack_public_path__ + "img/skills-mosaic-asn-2.2e9ff047.png";